import LottieWeb from 'lottie-react-web';
import React from 'react';

const Lottie = ({ source, width, height, style }) => (
  <LottieWeb options={{ animationData: source }} width={width} height={height} style={style} />
);

export default Lottie;
